module.exports = __webpack_public_path__ + "img/avatar2.e7b1661a.png";